export default "__VITE_ASSET__o8cC3X8w__"